if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // onSubmitHandler(evt) {
      //   evt.preventDefault();
      //   if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      //   if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

      //   this.handleErrorMessage();

      //   this.submitButton.setAttribute('aria-disabled', true);
      //   this.submitButton.classList.add('loading');
      //   //this.querySelector('.loading__spinner').classList.remove('hidden');

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData(this.form);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${theme.routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (response.status) {
      //         publish(PUB_SUB_EVENTS.cartError, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           errors: response.errors || response.description,
      //           message: response.message,
      //         });
      //         this.handleErrorMessage(response.description);

      //         const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
      //         if (!soldOutMessage) return;
      //         this.submitButton.setAttribute('aria-disabled', true);
      //         this.submitButtonText.classList.add('hidden');
      //         soldOutMessage.classList.remove('hidden');
      //         this.error = true;
      //         return;
      //       } else if (!this.cart) {
      //         window.location = theme.routes.cart_url;
      //         return;
      //       }

      //       if (!this.error)
      //         publish(PUB_SUB_EVENTS.cartUpdate, {
      //           source: 'product-form',
      //           productVariantId: formData.get('id'),
      //           cart: response,
      //         });
      //       this.error = false;
      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               this.cart.renderContents(response);
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         this.cart.renderContents(response);
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.submitButton.classList.remove('loading');
      //       if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      //       if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      //       //this.querySelector('.loading__spinner').classList.add('hidden');
      //     });
      // }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const MAX_RETRIES = 10;
        const RETRY_DELAY_MS = 300;
        const hasApoContainer = Boolean(document.querySelector('.mw-apo-container'));
        const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

        const getVariantById = async (variantIdKey) => {
          const startUri = window?.Shopify?.routes?.root || '/';
          const normalizedRoot = startUri.endsWith('/') ? startUri : `${startUri}/`;
          const url = `${normalizedRoot}variants/${variantIdKey}.js`;
          const res = await fetch(url, { credentials: 'same-origin' });
          if (!res.ok) return null;
          return res.json();
        };

        const buildRequest = async () => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);

          const idList = formData.getAll('id').filter(Boolean);
          const variantIdKey = idList.length ? String(idList[idList.length - 1]) : '';

          if (variantIdKey) {
            formData.delete('id');
            formData.append('id', variantIdKey);

            const variant = await getVariantById(variantIdKey);
            if (variant?.product_id) {
              formData.delete('product-id');
              formData.append('product-id', String(variant.product_id));
            }
          }

          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;
          return { config, formData };
        };

        const addToCartWith422Retry = async () => {
          const attempts = hasApoContainer ? MAX_RETRIES : 1;
          let lastResponse = null;
          let lastFormData = null;

          for (let i = 0; i < attempts; i++) {
            const { config, formData } = await buildRequest();
            lastFormData = formData;

            const raw = await fetch(`${theme.routes.cart_add_url}`, config);
            const json = await raw.json().catch(() => ({}));
            lastResponse = json;

            const is422 = raw.status === 422 || Number(json?.status) === 422;
            if (!is422) return { response: json, formData };

            if (i < attempts - 1) await sleep(RETRY_DELAY_MS);
          }

          return { response: lastResponse, formData: lastFormData };
        };

        try {
          const { response, formData } = await addToCartWith422Retry();

          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = theme.routes.cart_url;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cart: response,
            });
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => setTimeout(() => this.cart.renderContents(response)),
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        }
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
